<template>
  <PopupBase
    class="popup-hydraulic-selector-form"
    :show="props.show"
    close-on-outside-click
    @close-pop-up="emit('close-pop-up')"
  >
    <div class="popup-hydraulic-selector-form__header">
      <h5>{{ i18n.tv('contactUsHydraulicSelector', 'hydraulicSelector') }}</h5>
    </div>
    <div class="popup-hydraulic-selector-form__body">
      <div class="popup-hydraulic-selector-form__body__form">
        <ValidationForm
          ref="hydraulicSelectorValidationForm"
          :id="formId"
          use-model-values-for-validation
          :get-form="getForm"
          @success="submitForm"
        >
          <div class="hydraulic-form-row-1">
            <div class="hydraulic-form-column-left">
              <label
                id="hydraulic-first-name-label"
                class="hydraulic-form-label"
                for="hydraulic-first-name"
              >{{ i18n.tv('Frontend.TranslationContactFirstName', 'ORingConfiguratorImport') }} *</label>
              <InputText
                id="hydraulic-first-name"
                ref="validationFormFirstName"
                class="hydraulic-form-input-small"
                v-model="formData.firstName"
                name="firstName"
                aria-labelledby="hydraulic-first-name-label"
                :rules="[requiredValidationRule(i18n.tv('Frontend.TranslationContactFirstName', 'ORingConfiguratorImport'))]"
                :placeholder="i18n.tv('Frontend.PdfDownload.Placeholder.FirstName', 'ORingConfigurator')"
              />
            </div>
            <div>
              <label
                id="hydraulic-last-name-label"
                class="hydraulic-form-label"
                for="hydraulic-last-name"
              >{{ i18n.tv('Frontend.TranslationContactLastName', 'ORingConfiguratorImport') }} *</label>
              <InputText
                id="hydraulic-last-name"
                ref="validationFormLastName"
                class="hydraulic-form-input-small"
                v-model="formData.lastName"
                name="lastName"
                aria-labelledby="hydraulic-last-name-label"
                :rules="[requiredValidationRule(i18n.tv('Frontend.TranslationContactLastName', 'ORingConfiguratorImport'))]"
                :placeholder="i18n.tv('Frontend.PdfDownload.Placeholder.LastName', 'ORingConfigurator')"
              />
            </div>
          </div>
          <div class="hydraulic-form-row-2">
            <div class="hydraulic-form-column-left">
              <label
                id="hydraulic-company-label"
                class="hydraulic-form-label"
                for="hydraulic-company"
              >{{ i18n.tv('Frontend.PdfDownload.Label.Company', 'ORingConfiguratorImport') }} *</label>
              <InputText
                id="hydraulic-company"
                ref="validationFormCompany"
                class="hydraulic-form-input-small"
                v-model="formData.company"
                name="company"
                aria-labelledby="hydraulic-company-label"
                :rules="[requiredValidationRule(i18n.tv('Frontend.PdfDownload.Label.Company', 'ORingConfiguratorImport'))]"
                :placeholder="i18n.tv('Frontend.PdfDownload.Placeholder.Company', 'ORingConfiguratorImport')"
              />
            </div>
            <div>
              <label
                id="hydraulic-email-label"
                class="hydraulic-form-label"
                for="hydraulic-email"
              >{{ i18n.tv('Frontend.PdfDownload.Label.EMail', 'ORingConfiguratorImport') }} *</label>
              <InputText
                id="hydraulic-email"
                ref="validationFormEmail"
                class="hydraulic-form-input-small"
                v-model="formData.email"
                name="email"
                aria-labelledby="hydraulic-email-label"
                :rules="[emailValidationRule(i18n.tv('Frontend.PdfDownload.Label.EMail', 'ORingConfiguratorImport'))]"
                :placeholder="i18n.tv('Frontend.PdfDownload.Placeholder.Email', 'ORingConfiguratorImport')"
              />
            </div>
          </div>
          <div class="hydraulic-form-row-3">
            <div class="hydraulic-form-column-left">
              <label
                id="hydraulic-telephone-label"
                class="hydraulic-form-label"
                for="hydraulic-telephone"
              >{{ i18n.tv('rfqPopupFormLabelPhone', 'partnerHub') }}</label>
              <InputText
                id="hydraulic-telephone"
                ref="validationFormTelephone"
                class="hydraulic-form-input-small"
                v-model="formData.telephone"
                name="telephone"
                aria-labelledby="hydraulic-telephone-label"
                :placeholder="i18n.tv('rfqPopupFormPlaceholderPhone', 'partnerHub')"
              />
            </div>
            <div />
          </div>
          <div class="hydraulic-form-row-4">
            <div class="hydraulic-form-column-left">
              <label
                id="hydraulic-country-label"
                class="hydraulic-form-label"
                for="hydraulic-country"
              >{{ i18n.tv('country', 'contactForm') }} *</label>
              <ComboDropDown
                id="hydraulic-country"
                ref="validationFormCountry"
                class="hydraulic-form-input-small"
                name="country"
                v-model="formData.country"
                aria-labelledby="hydraulic-country-label"
                :data-items="countryOptions"
                text-field="text"
                data-item-key="value"
                value-field="value"
                :value-primitive="true"
                :filterable="true"
                :rules="[requiredValidationRule(i18n.tv('country', 'contactForm'))]"
              />
            </div>
            <div v-if="!isLoggedIn">
              <label
                id="hydraulic-industry-type-label"
                class="hydraulic-form-label"
                for="hydraulic-industry-type"
              >{{ i18n.tv('rfqPopupFormLabelIndustry', 'partnerHub') }} *</label>
              <DropDown
                id="hydraulic-industry-type"
                ref="validationFormIndustryType"
                class="hydraulic-form-input-small"
                name="industryType"
                v-model="formData.industryType"
                aria-labelledby="hydraulic-industry-type-label"
                :data-items="industryTypeOptions"
                text-field="text"
                data-item-key="value"
                value-field="value"
                :value-primitive="true"
                :rules="!isLoggedIn ? [requiredValidationRule(i18n.tv('rfqPopupFormLabelIndustry', 'partnerHub'))] : []"
              />
            </div>
            <div v-else />
          </div>
          <div
            v-if="showSpecificIndustry && !isLoggedIn"
            class="hydraulic-form-row-5"
          >
            <div>
              <label
                id="hydraulic-specific-industry-label"
                class="hydraulic-form-label"
                for="hydraulic-specific-industry"
              >{{ i18n.tv('rfqPopupFormLabelLeadMarket', 'partnerHub') }} *</label>
              <DropDown
                id="hydraulic-specific-industry"
                ref="validationFormSpecificIndustry"
                class="hydraulic-form-input-small"
                name="specificIndustry"
                v-model="formData.specificIndustry"
                aria-labelledby="hydraulic-specific-industry-label"
                :data-items="specificIndustryOptions"
                text-field="text"
                data-item-key="value"
                value-field="value"
                :value-primitive="true"
                :rules="showSpecificIndustry && !isLoggedIn ? [requiredValidationRule(i18n.tv('rfqPopupFormLabelLeadMarket', 'partnerHub'))] : []"
              />
            </div>
          </div>
          <div class="hydraulic-form-row-6">
            <label
              id="hydraulic-message-label"
              class="hydraulic-form-label"
              for="hydraulic-message"
            >{{ i18n.tv('rfqPopupFormLabelComments', 'partnerHub') }}</label>
            <textarea
              id="hydraulic-message"
              ref="validationFormMessage"
              class="hydraulic-form-textarea"
              v-model="formData.message"
              name="message"
              rows="4"
              :placeholder="i18n.tv('rfqPopupFormPlaceholderComments', 'partnerHub')"
              aria-labelledby="hydraulic-message-label"
            />
          </div>
          <div class="hydraulic-form-row-7">
            <Checkbox
              v-if="showMarketingCheckbox"
              class="hydraulic-form-checkbox"
              v-model="formData.marketingConsent"
              name="marketingConsent"
              :value="formData.marketingConsent"
              :label="i18n.tv('marketingConsentText', 'leadform', 'I agree that Freudenberg FST GmbH may send me emails with information about related sealing products. You can withdraw this consent at any time. At the end of each email, you will find a corresponding link to unsubscribe.')"
              :use-markdown="true"
            />
            <div class="hydraulic-form-privacy-text">
              <p v-html="privacyPolicyLinkHtml" />
            </div>
            <div class="hydraulic-form-row-mandatory">
              <span class="mandatory-fields">
                {{ i18n.tv('mandatoryFields', 'contactForm') }}
              </span>
            </div>
          </div>

          <div class="hydraulic-form-row-8">
            <ReactiveButton
              type="submit"
              :button-text="i18n.tv('rfqPopupFormSubmit', 'partnerHub')"
              :is-primary-button="false"
              :is-loading="isLoading"
            />
          </div>
          <input
            hidden
            name="firstName"
            :value="formData.firstName"
          >
          <input
            hidden
            name="lastName"
            :value="formData.lastName"
          >
          <input
            hidden
            name="description"
            :value="formCaptureDescription"
          >
          <input
            v-if="!isLoggedIn"
            hidden
            name="initialIndustry"
            :value="formData.industryType"
          >
          <input
            hidden
            name="marketingLanguage"
            :value="formCaptureMarketingLanguage"
          >
          <input
            hidden
            name="country"
            :value="formCaptureCountry"
          >
          <input
            hidden
            name="leadMarket"
            :value="formData.specificIndustry"
          >
          <!-- ERP fields for logged-in users -->
          <input
            v-if="isLoggedIn"
            hidden
            name="easyAccountNumber"
            :value="companyNo"
          >
          <input
            v-if="isLoggedIn"
            hidden
            name="easySalesOrganization"
            :value="salesOrganization"
          >
          <!-- Metadata field (always present) -->
          <input
            hidden
            name="metadata"
            :value="formCaptureMetadata"
          >
        </ValidationForm>
      </div>
    </div>
  </PopupBase>
</template>

<script setup lang="ts">

import ValidationForm from '~/components/input-components/ValidationForm.vue'
import InputText from '~/components/input-components/InputText.vue'
import DropDown from '~/components/input-components/DropDown.vue'
import ComboDropDown from '~/components/input-components/ComboDropDown.vue'
import Checkbox from '~/components/input-components/Checkbox.vue'
import useI18nExtended from '~/composables/usei18nExtended'
import {
  emailValidationRule,
  requiredValidationRule
} from 'assets/js/validations/common_validation_rules'
import {AllowMarketingEmailsKey} from '~/assets/js/constants'
import {useDynamicsLeadCapture} from '~/composables/useDynamicsLeadCapture'
import {useFormDropdowns} from '~/composables/useFormDropdowns'
import {useFormPrefill} from '~/composables/useFormPrefill'
import {useFormPrivacyText} from '~/composables/useFormPrivacyText'
import {generateFormId} from '~/utils/generateFormId'
import {useUserStore} from '@/store/user'

const userStore = useUserStore()

// Check if user is logged in
const isLoggedIn = computed(() => userStore.loggedIn)

// ERP fields for logged-in users
const companyNo = computed(() => {
  if (!isLoggedIn.value) {return ''}
  return (userStore.selectedCustomer as any)?.customerNo || ''
})

const salesOrganization = computed(() => {
  if (!isLoggedIn.value) {return ''}
  const c = userStore.selectedCustomer as any
  if (!c?.salesOrg) {return ''}
  return `${c.salesOrg}-${c.salesChannel}-${c.distribution}`
})

const app = useNuxtApp()
const i18n = useI18nExtended()
const dynamicsCapture = useDynamicsLeadCapture()
const {getExtendedPrefillData} = useFormPrefill()
const {
  countryOptions,
  industryTypeOptions,
  specificIndustryOptions,
  shouldShowSpecificIndustry
} = useFormDropdowns()
const {privacyPolicyLinkHtml} = useFormPrivacyText()
const emit = defineEmits(['close-pop-up'])

const props = defineProps({
  show: {
    type: Boolean,
    default() {
      return false
    }
  },
  selectorData: {
    type: Object,
    default() {
      return null
    }
  }
})

// Form data with prefilling from shared composable
const prefillData = getExtendedPrefillData()
const formData = ref({
  firstName: prefillData.firstName,
  lastName: prefillData.lastName,
  company: prefillData.company,
  email: prefillData.email,
  telephone: prefillData.phone,
  country: prefillData.country || null,
  industryType: (prefillData.industryType ? Number(prefillData.industryType) : null) as number | null,
  specificIndustry: (prefillData.specificIndustry ? Number(prefillData.specificIndustry) : null) as number | null,
  leadMarket: prefillData.leadMarket || null,
  message: '',
  marketingConsent: false
})

const formId = ref(generateFormId('hydraulicSelectorForm'))
let isLoading = ref<boolean>(false)

// Conditional display for Specific Industry dropdown (labeled as Lead Market)
const showSpecificIndustry = computed(() => {
  return shouldShowSpecificIndustry(formData.value.industryType)
})

// Build description with user message only (metadata goes to separate field)
const formCaptureDescription = computed(() => {
  return formData.value.message || ''
})

// Build metadata with hydraulic selector parameters
const formCaptureMetadata = computed(() => {
  return dynamicsCapture.buildDescriptionAppendix({
    formType: 'hydraulicSelector',
    hydraulicSelector: {
      parameters: props.selectorData
    }
  })
})

const formCaptureMarketingLanguage = computed(() => {
  return dynamicsCapture.getLanguageObject(i18n.locale.value)
})

const formCaptureCountry = computed(() => {
  return formData.value.country || dynamicsCapture.getCountryObject()
})

// Show marketing checkbox only if user hasn't already consented via login wizard
const showMarketingCheckbox = computed(() => {
  if (!isLoggedIn.value) {return true}
  const marketingSetting = userStore.settings?.find((s: any) => s.key === AllowMarketingEmailsKey) as {value?: string} | undefined
  return marketingSetting?.value !== '1'
})

const getForm = () => {
  return formData.value
}

const submitForm = async () => {
  isLoading.value = true

  try {
    // Load the D365 form capture script if not already loaded
    await dynamicsCapture.loadFormCaptureScript()

    const captureData: Record<string, any> = {
      firstName: formData.value.firstName,
      lastName: formData.value.lastName,
      company: formData.value.company,
      email: formData.value.email,
      telephone: formData.value.telephone,
      description: formCaptureDescription.value,
      marketingLanguage: formCaptureMarketingLanguage.value,
      country: formCaptureCountry.value,
      metadata: formCaptureMetadata.value
    }

    // Add industry fields only for logged-out users
    if (!isLoggedIn.value) {
      captureData.initialIndustry = formData.value.industryType
      captureData.leadMarket = formData.value.specificIndustry
    }

    // Add ERP fields for logged-in users
    if (isLoggedIn.value) {
      captureData.easyAccountNumber = companyNo.value
      captureData.easySalesOrganization = salesOrganization.value
    }

    const hasMarketingConsent = formData.value.marketingConsent
    await dynamicsCapture.captureFormData('hydraulicSelector', captureData, i18n.locale.value, isLoggedIn.value, hasMarketingConsent)

    if (isLoggedIn.value && hasMarketingConsent) {
      try {
        const marketingSetting = userStore.settings?.find((setting: any) => setting.key === AllowMarketingEmailsKey) as Record<string, any> | undefined
        if (marketingSetting && marketingSetting.value !== '1') {
          await userStore.updateSettings([{
            ...marketingSetting,
            value: '1'
          }])
        }
      } catch {
        // Don't block submission success if persisting the setting fails
      }
    }

    const toast = app.$toast as any
    toast.success(i18n.tv('rfqPopupFormToastSuccess', 'partnerHub'))
    isLoading.value = false
    emit('close-pop-up')
  } catch {
    const toast = app.$toast as any
    toast.error(i18n.tv('rfqPopupFormToastError', 'partnerHub'))
    isLoading.value = false
  }
}

</script>

<style lang="scss">
.popup-hydraulic-selector-form {
  max-width: 30.813rem;

  .hydraulic-form-label {
    font-weight: 300;
    font-size: 0.875rem;
    margin-bottom: 0.313rem;
  }

  &__header {
    h5 {
      margin: -.5rem 0 1rem;
    }
  }

  &__body {
    max-width: 100%;

    ::placeholder {
      opacity: 0.5;
    }

    &__form {
      .hydraulic-form-input-small {
        min-width: 14.594rem;
        margin-top: 0.375rem;
      }

      .hydraulic-form-textarea {
        margin-top: 0.375rem;
        padding: 0.5rem;
        border: 0.0625rem solid $color--input__border;
        border-radius: 0.25rem;
        font-family: inherit;
        font-size: 0.875rem;

        &:focus {
          outline: none;
          border-color: $color--input--focus;
        }
      }

      .hydraulic-form-column-left {
        margin-right: 1.5rem;
      }

      .hydraulic-form-row-1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .75rem;

        > div {
          flex-basis: calc(50%);
        }

        span {
          min-height: 0;
        }
      }

      .hydraulic-form-row-2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.5rem;

        > div {
          flex-basis: calc(50%);
        }

        span {
          min-height: 0;
        }
      }

      .hydraulic-form-row-3 {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 1.5rem;

        > div {
          flex-basis: calc(50%);
        }

        span {
          min-height: 0;
        }
      }

      .hydraulic-form-row-4 {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 1.5rem;

        > div {
          flex-basis: calc(50%);
        }

        span {
          min-height: 0;
        }
      }

      .hydraulic-form-row-5 {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 1.5rem;

        span {
          min-height: 0;
        }
      }

      .hydraulic-form-row-6 {
        display: flex;
        flex-direction: column;
        margin-top: 1.5rem;
      }

      .hydraulic-form-row-7 {
        margin-top: 1.5rem;

        .hydraulic-form-checkbox {
          display: flex;

          span {
            min-height: 0;
            align-items: flex-start;
          }

          p {
            margin: 0;
          }

          input[type="checkbox"] {
            margin-top: 0.1875rem;
          }
        }

        label {
          font-weight: 300;
          font-size: 0.875rem;
          cursor: default;
        }
      }

      .hydraulic-form-row-mandatory {
        margin-top: 1.5rem;

        .mandatory-fields {
          font-size: 0.875rem;
          font-weight: $base-text-font-weight-light;
        }
      }

      .hydraulic-form-row-8 {
        display: flex;
        justify-content: flex-end;
        margin-top: 2rem;
      }

      // ComboBox (country field) styling fixes
      .k-combobox {
        border: .0625rem solid $color--input__border;

        .k-button {
          .k-icon {
            min-height: auto;
            width: 2.5rem;
            background-color: transparent;
            color: $color__fst_gray__100;
            padding: .5rem;
          }
        }

        &.k-input:focus {
          border-color: $color--input__border;
        }
      }
    }
  }
}
</style>
